import React from 'react';
import './footer.css';

const Footer = () => (
  <footer className="footer-fixed">
    <p>&copy; 2024 Event Planner. All rights reserved.</p>
        <p>Event Planner’s uses and transfer to any other app of information received from Google APIs will adhere to Google API Services User Data Policy, including the Limited Use requirements.</p>
        <p>
        Limited Use Requirements: <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>
      </p>  
      </footer>
);

export default Footer;